import CopyTrackWrapper from '@/components/CopyTrackWrapper'
import StrategyBanner from '@/components/strategies/details/StrategyBanner'
import StrategyResourceList from '@/components/strategies/details/StrategyResourceList'
import StrategyPanels from '@/components/strategies/details/StrategyPanels'
import StrategyRelated from '@/components/strategies/details/StrategyRelated'
import SubmitFeedback from '@/components/SubmitFeedback'
import ResearchCitationPanels from '@/components/ResearchCitationPanels'

export { strategyPageMixin }

const strategyPageMixin = {
  components: {
    CopyTrackWrapper,
    StrategyBanner,
    StrategyResourceList,
    StrategyPanels,
    StrategyRelated,
    SubmitFeedback,
    ResearchCitationPanels
  },
  data() {
    return {
      bannerProps: null,
      resourcesProps: null,
      implementationProps: null,
      examplesProps: null,
      relatedProps: null,
      researchCitationProps: null
    }
  },
  methods: {
    setCommonProps(strategyData, verifiedLibraryGoal) {
      this.bannerProps = {
        uuid: strategyData.uuid,
        title: strategyData.title,
        altNames: strategyData.alt_names,
        description: strategyData.description,
        udlStandards: strategyData.udl_standards,
        imageUrl: strategyData.image_url
      }

      this.resourcesProps = {
        resources: strategyData.resources
      }

      this.implementationProps = {
        title: 'Implementation Tips',
        panelData: strategyData.tips.map(this.getPanelDataFromText),
        overwriteBlur: verifiedLibraryGoal || false
      }

      this.examplesProps = {
        title: 'Examples',
        panelData: strategyData.examples.map(this.getPanelDataFromText),
        overwriteBlur: verifiedLibraryGoal || false
      }
      if (strategyData.research_citations && strategyData.research_citations.length) {
        this.researchCitationProps = strategyData.research_citations
      }

      if (strategyData.related_adaptations && strategyData.related_adaptations.length) {
        this.relatedProps = {
          relatedStrategies: strategyData.related_adaptations.filter(s => s.published === true)
        }
      }
    },
    getPanelDataFromText(elem) {
      let sliceIndex = elem.text.indexOf('\n')
      return {
        title: elem.text.slice(0, sliceIndex),
        text: elem.text.slice(sliceIndex)
      }
    }
  }
}
